import * as $http from 'axios'

export default {
    all: () => $http.get('v2/friends'),
    // payload EX: { type: 'new', message: 'hi', gender: 'male', num: 5, is_direct: false }
    request: payload => $http.post('v2/friends', payload),
    updateFriend: (friendId, payload) => $http.put(`v2/friends/${friendId}`, payload),
    disconnectFriend: () => $http.delete(`v2/friends/disconnect_all`),
}
